'use strict';

var sink = function sink() {};

var _match = function _match(either, patterns) {
  return either.fold(patterns.Error || sink, patterns.Ok || sink);
};

var left = function left(value) {
  return {
    map: function map(fn) {
      return this;
    },
    fold: function fold(f, g) {
      return f(value);
    },
    chain: function chain(fn) {
      return this;
    },
    match: function match(patterns) {
      return _match(this, patterns);
    },

    value: value
  };
};

var right = function right(value) {
  return {
    map: function map(fn) {
      return right(fn(value));
    },
    fold: function fold(f, g) {
      return g(value);
    },
    chain: function chain(fn) {
      return fn(value);
    },
    match: function match(patterns) {
      return _match(this, patterns);
    },

    value: value
  };
};

var sequence = function sequence(eitherList) {
  return eitherList.reduce(function (acc, either) {
    return acc.chain(function (list) {
      return either.map(function (value) {
        return list.concat(value);
      });
    });
  }, right([]));
};

var try_ = function try_(fn) {
  try {
    return right(fn());
  } catch (e) {
    return left(e);
  }
};

var Either = {
  Left: left,
  Right: right
};

module.exports = {
  Either: Either,
  sequence: sequence,
  try_: try_
};